module.exports = __webpack_public_path__ + "static/media/grid-item-a9.aa5b943b.png";